import { useEffect } from "react";

import Home from "./pages/Home";
import Roadmap from "./pages/Roadmap";
import Utilities from "./pages/Utilities";
import Welcome from "./pages/Welcome";
import Exploring from "./pages/Exploring";
import EcolocationRewards from "./pages/EcolocationRewards";

import img from "./assets/home_img.png";
import Team from "./pages/Team";

const App = () => {
  useEffect(() => {
    const body = document.getElementsByTagName("body")[0];
    body.style.backgroundImage = `url(${img})`;
  }, []);

  return (
    <div>
      <Home />
      <Welcome />
      <Exploring />
      <EcolocationRewards />
      {/* <About /> */}
      <Utilities />
      <Roadmap />
      <Team />
      {/* <FAQ /> */}
    </div>
  );
};

export default App;
